import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import TreeNode from '../components/TreeNode';
import '../css/TreeView.css';



const TreeView = ({ showDatesDialog, handleDatesClose, onLinkClick, datesUrl }) => {
  // State to store the dates from the JSON file
  const [dates, setDates] = useState(null);
  // State to handle the loading status
  const [isDatesLoading, setIsDatesLoading] = useState(true);
  // State to handle any potential errors
  const [datesError, setDatesError] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState({});
  const [expanded, setExpanded] = useState(false);

  const handleCollapseAll = () => {
    setExpandedNodes({});
    setExpanded(false);
  };

  const getAllExpandablePaths = (node, currentPath = '') => {
    const paths = [];
    if (typeof node === 'object' && node !== null) {
      const pathKey = currentPath;
      if (pathKey) paths.push(pathKey);
      for (const key in node) {
        paths.push(...getAllExpandablePaths(node[key], pathKey ? `${pathKey}/${key}` : key));
      }
    }
    return paths;
  };
  
  const handleExpandAll = () => {
    const allPaths = getAllExpandablePaths(dates);
    const expandedMap = Object.fromEntries(allPaths.map(path => [path, true]));
    setExpandedNodes(expandedMap);
    setExpanded(true);
  };

  // The useEffect hook runs after the component mounts
  useEffect(() => {
    // Define the async function to fetch data
    const fetchDates = async () => {
      // Don't do anything if there are already dates loaded.
      // This prevents re-fetching if the dialog is hidden and then shown again.
      if (dates) return;

      setIsDatesLoading(true);
      try {
        // get dates.json
        const response = await fetch(datesUrl);
        
        // Check if the network response was successful
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setDates(data); 
      } catch (e) {
        setDatesError(e.message);
        console.error("Failed to fetch dates:", e);
      } finally {
        // Set loading to false once the fetch is complete (either success or error)
        setIsDatesLoading(false);
      }
    };
    if (showDatesDialog && datesUrl) {
      fetchDates();
    }
  }, [showDatesDialog, datesUrl, dates]); 

  if (!showDatesDialog) return null;

  // 1. Render a loading message while fetching
  if (isDatesLoading) {
    return       ( <div className="dialog-left-overlay">
    <div className="dialog">Loading...</div>
  </div> );
  } 

  // 2. Render an error message if the fetch failed
  if (datesError) {
    return <div>Error: {datesError}</div>;
  }

  return (
    <div className="dialog-left-overlay">
      <div className="dialog">
        <div className="treeview-header">
          <h3>TV History</h3>
          <div className="treeview-actions">
          { ! expanded ? (<span className="expand-btn" onClick={handleExpandAll}>Expand All</span>) : 
          ( <span className="collapse-btn" onClick={handleCollapseAll}>Collapse All</span> )
          }
          <button className="close-btn" onClick={handleDatesClose}><FontAwesomeIcon icon={faClose} /></button>
          </div>
        </div>
        
        <div className="tree-view">
          {Object.entries(dates).map(([key, value]) => (
            <TreeNode
              key={key}
              node={value}
              nodeKey={key}
              onLinkClick={onLinkClick}
              expandedNodes={expandedNodes}
              setExpandedNodes={setExpandedNodes}
              path=""
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TreeView;